import { useQuery } from '@tanstack/react-query';

import { feedKeys } from '@/lib/queries/feed';

// Viewer-scoped post-composer capability bits (GET /posts/capabilities).
// Today that's one bit: whether poll authoring (`feed.polls`) is on for this
// member. Client gating is cosmetic — the create route re-checks the flag —
// so the UI is default-deny: no poll button until the server positively says
// yes. `enabled: false` skips the fetch on surfaces that never show the button
// (e.g. the edit composer).

export function usePollComposerEnabled(opts: { enabled?: boolean } = {}): boolean {
  const { data } = useQuery({
    ...feedKeys.capabilities(),
    enabled: opts.enabled ?? true,
  });
  return data?.pollsEnabled ?? false;
}
